/** Переключатель настроек: `role="switch"`, крупная цель для пальца. */

export function SetSwitch({
  label,
  checked,
  disabled,
  hideLabel = false,
  onChange,
}: {
  label: string;
  checked: boolean;
  disabled?: boolean;
  hideLabel?: boolean;
  onChange: (on: boolean) => void;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={hideLabel ? label : undefined}
      className={`set-switch${checked ? ' set-switch--on' : ''}`}
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <span className="set-switch__track" aria-hidden="true">
        <span className="set-switch__thumb" />
      </span>
      {!hideLabel && <span className="set-switch__label">{label}</span>}
    </button>
  );
}
